export const API_BASE = 'https://mab-myblog.nocloudware.workers.dev';

export class Publisher {
  constructor() {
    this.token = localStorage.getItem('adminToken') || '';
  }

  get loggedIn() {
    return Boolean(this.token);
  }

  async login(password) {
    const r = await fetch(`${API_BASE}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.error || 'Error al iniciar sesión');
    this.token = j.token;
    localStorage.setItem('adminToken', j.token);
  }

  logout() {
    this.token = '';
    localStorage.removeItem('adminToken');
  }

  async loadPost(slug) {
    const r = await fetch(`${API_BASE}/api/posts/${slug}`);
    const j = await r.json();
    if (!r.ok) throw new Error(j.error || 'No se pudo cargar el artículo');
    return j;
  }

  async savePost({ slug, title, content, hashtags, fontFamily, featured, images }) {
    const fd = new FormData();
    fd.append('title', title);
    fd.append('content', content);
    fd.append('hashtags', hashtags || '');
    fd.append('fontFamily', fontFamily || '');
    if (featured) fd.append('image', featured, 'featured.webp');
    for (const img of images) fd.append('images[]', img.file, img.name);
    const headers = { Authorization: `Bearer ${this.token}` };
    const url = slug ? `${API_BASE}/api/posts/${slug}` : `${API_BASE}/api/posts`;
    const r = await fetch(url, { method: slug ? 'PUT' : 'POST', headers, body: fd });
    const j = await r.json();
    if (!r.ok) throw new Error(j.error || 'Error al guardar');
    return j;
  }

  async publish({ slug, platforms, message }) {
    const r = await fetch(`${API_BASE}/api/publish`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${this.token}` },
      body: JSON.stringify({ slug, platforms, message }),
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.error || 'Error al publicar');
    return j;
  }
}
